import { connect } from 'react-redux'
import LoadMoreButton from './load-more-button'
import { loadMoreTeachers } from '../../../../stores/teachers/teachers.actions'
import {
  getFetchTeachersRequest,
  getFetchTeachersRequestInitiator
} from '../../../../stores/teachers/teachers.selectors'

const mapStateToProps = state => ({
  pending:
    getFetchTeachersRequest(state) &&
    getFetchTeachersRequestInitiator(state) === 'LOAD_MORE'
})

const mapDispatchToProps = dispatch => ({
  onLoadMore: () => dispatch(loadMoreTeachers())
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LoadMoreButton)
